import { errorCodeToErrorMessageMapping } from '@bingads-webui-campaign/reports-v4-data-source';
import { ErrorHandlePipeFactory } from '@bingads-webui-campaign/react-hook-use-fetch';
import reportNameColumn from './report-name-column';
import reportBaseColumn from './report-base-column';
import scheduledFrequencyColumn from './scheduled-frequency-column';
import dateRangeColumn from './date-range-column';
import createByColumn from './createde-by-column';
import sharedColumn from './shared-column';
import lastAccessedColumn from './last-accessed-column';
import createdOnColumn from './created-on-column';


export function buildColumns({
  i18n, legacyI18n, serverContext, ctrLogger, inlineDownloadDuplicate, handleInlineEditSuccess, type, permissions,
}) {
  const notifyErrorPipe = ErrorHandlePipeFactory.createNotifyErrorHandlerPipe(i18n, errorCodeToErrorMessageMapping);
  return [
    reportNameColumn({
      i18n, ctrLogger, inlineDownloadDuplicate, handleInlineEditSuccess, notifyErrorPipe, permissions,
    }),
    reportBaseColumn({ i18n }),
    scheduledFrequencyColumn({
      i18n, legacyI18n, handleInlineEditSuccess, notifyErrorPipe,
    }),
    dateRangeColumn({
      i18n, legacyI18n, handleInlineEditSuccess, notifyErrorPipe,
    }),
    ...(type === 'Shared' ? [createByColumn({ i18n })] : []),
    sharedColumn({ i18n }),
    lastAccessedColumn({ i18n, serverContext }),
    createdOnColumn({ i18n, serverContext }),
  ];
}
